import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { FairySil } from "@/components/site/Motifs";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="not-found">
      <Seo title="Sayfa bulunamadı" />
      <FairySil className="mx-auto w-24 text-navy motif-float" />
      <h1 className="mt-6 font-heading text-4xl font-black text-navy">Bu sayfa masalda kaybolmuş</h1>
      <Link to="/" className="mt-8 inline-block rounded-full bg-navy px-7 py-3 font-bold text-white">Ana sayfaya dön</Link>
    </div>
  );
}
